export const ErightsActionTypes = {
    API_RESPONSE_SUCCESS: '@@erights/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@erights/API_RESPONSE_ERROR',

    GET_ERIGHT: '@@erights/GET_ERIGHT',
    LIST_ERIGHTS: '@@erights/LIST_ERIGHTS',
    ADD_ERIGHT: '@@erights/ADD_ERIGHT',
    UPDATE_ERIGHT: '@@erights/UPDATE_ERIGHT',
    DELETE_ERIGHT: '@@erights/DELETE_ERIGHT',

    RESET: '@@erights/RESET',
};
